import { Injectable } from '@angular/core';
import { ToolsService } from '../../../tools/tools.service';
import { Base2Service } from '../../base2.service';
import * as moment from 'moment';
import { allergens } from 'src/app/consts/allergens';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { FulleStockService } from '../fulle-stock/fulle-stock.service';
import { BaseclientService } from '../../../apiclient/baseclient.service';
import { LangagesService } from '../../../manage/langages/langages.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import { SalemethodService } from "../../salemethod/salemethod.service";
import { PricePeriod, ProductParams, FulleProducts, FulleParsedProds, FulleProduct, Suggestions } from './fulle-product.interface';
import { PanierService } from 'src/app/services/manage/panier/panier.service';
import { ProductSuggestionsComponent } from 'src/app/components/dialogs/product-suggestions/product-suggestions.component';
import { SaleMethodSlim } from 'src/app/components/order/fulle-selection-SM/fulle-selection-SM.interface';

@Injectable({
  providedIn: 'root'
})
export class FulleProductService {
  private obserGetProduct: BehaviorSubject<any> = new BehaviorSubject(null);
  private allergens: any[] = allergens;
  private obserLoaderProductsSuggested: BehaviorSubject<any> = new BehaviorSubject(null);
  private obserLoaderFormulesSuggested: BehaviorSubject<any> = new BehaviorSubject(null);
  private ObserProductTypeformule: BehaviorSubject<any> = new BehaviorSubject(null);
  private ObsersuggestionsEnd: BehaviorSubject<any> = new BehaviorSubject(null);
  public pricePeriods: any = [];
  Mysuggestions: any;

  constructor(
    private base2: Base2Service,
    private tools: ToolsService,
    private stockApi: FulleStockService,
    private baseClient: BaseclientService,
    private langServ: LangagesService,
    public translate: TranslateService,
    public dialog: MatDialog,
    public media: MediaObserver
  ) {
  }

  // Return the Observable getobserGetProduct
  getobserGetProduct(): Observable<any> {
    return this.obserGetProduct.asObservable();
  }

  //set for get prodcut
  setobserGetProduct(value?: any): void {
    value = value ? value : null;
    this.obserGetProduct.next(value);
  }

  ////// Suggestions //////

  // Return the Observable LoaderProductsSuggested
  getObserLoaderProductsSuggested(): Observable<any> {
    return this.obserLoaderProductsSuggested.asObservable();
  }

  //set for LoaderProductsSuggested
  setObserLoaderProductsSuggested(value?: any): void {
    value = value ? value : null;
    this.obserLoaderProductsSuggested.next(value);
  }

  // Return the Observable Loader Formules Suggested
  getObserLoaderFormulesSuggested(): Observable<any> {
    return this.obserLoaderFormulesSuggested.asObservable();
  }

  //set for LoaderFormulePSuggested
  setObserLoaderFormulePSuggested(value?: any, close?: any): void {

    const set = {
      value: value ? value : null,
      close: close ? close : null,

    }
    this.obserLoaderFormulesSuggested.next(set);

  }

  // Return the Observable ObserProductTypeformule
  getObserProductTypeformule(): Observable<any> {
    return this.ObserProductTypeformule.asObservable();
  }

  // Return the Observable ObsersuggestionsEnd
  getObsersuggestionsEnd(): Observable<any> {
    return this.ObsersuggestionsEnd.asObservable();
  }

  //set for setObsersuggestionsEnd
  setObsersuggestionsEnd(value?: any): void {
    const value_ = value ? value : null;
    this.ObsersuggestionsEnd.next(value_);
  }

  getValidSlots(dateOrder?: any): Promise<any> {
    const date = dateOrder ? dateOrder : this.tools.getStor("date_order");
    const pos: any = this.tools.getStor("point_of_sale");
    const sm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    const params = {
      pos_id: pos.id,
      sm_id: sm.id,
      date_order: moment(date).format("YYYY-MM-DD"),
      id_merchant: this.tools.getStor("id_merchant")
    }
    return this.baseClient.postBase("getValidSlots", params);
  }

  // Récupération des périodes de prix
  getPricePeriods(): Observable<any> {
    // Recupération API
    return from(new Promise((resolve) => {
      this.baseClient.postBaseApi("price_periods").then(pricePeriods => {
        this.pricePeriods = pricePeriods;
        resolve(pricePeriods)
      });
    }));
  }

  // Récupération d'un objet price_period
  searchPricePeriodById(id: number) {
    if (this.pricePeriods.list) {
      for (const currentValue of this.pricePeriods.list) {
        if (currentValue.id === id) {
          return currentValue;
        }
      }
    }
    return null;
  }

  // Récupération d'un nom price_period
  getPricePeriodName(id: number) {
    const pricePeriod = this.searchPricePeriodById(id)
    if (pricePeriod != null) {
      return pricePeriod.name;
    }
    return "";
  }

  // @description add stock categories
  addstockCat(products: any): void {
    for (let i = 0; i < products.categories.length; i++) {
      const item = products.categories[i];
      if (item.details.length > 0) {
        for (let j = 0; j < item.details.length; j++) {
          item.details[j].product.stock = this.stockApi.stocks[item.details[j].product.id];

        }
      }
    }
  }

  // Récupère la galerie d'image d'un produit
  getGallery(productId: number): Promise<any> {
    return this.base2.getBase("products_gallery/" + productId);
  }

  $_getGallery(productId: number): Promise<any> {
    const params = {
      id_product: productId
    };
    return this.baseClient.postBaseApi("products/gallery", params);
  }


  // Parse le tableau d'id d'allergene du produit en lui ajoutant un nom
  parseAllergens(prodAllergens: any): any[] {
    const parsedAllergens = [];
    if (prodAllergens) {
      for (let i = 0; i < prodAllergens.length; i++) {
        const prodAllergensId = prodAllergens[i];
        for (let j = 0; j < this.allergens.length; j++) {
          const allergens = this.allergens[j];
          if (prodAllergensId === allergens.id) {
            allergens.name = this.translate.instant('allergens.' + allergens.id);
            parsedAllergens.push(allergens);
            break;
          }
        }
      }
    }
    return parsedAllergens;
  }

  getValidTimeTables(pointOfSale: any, saleMethod_id: any): any[] {
    let validTimeTables = pointOfSale.timetables;
    if (pointOfSale.timetables_sm) {
      for (let index = 0; index < pointOfSale.timetables_sm.length; index++) {
        const timeTable = pointOfSale.timetables_sm[index];
        if (timeTable.id_sale_method === saleMethod_id) {
          validTimeTables = timeTable.timetables;
          break;
        }
      }
    }
    return validTimeTables;
  }

  getParamsProducts(smId: number, rubric_id: string | number | null, $limit_from: number | null, search: string | null): ProductParams {
    const now = moment();
    const dateOrder = this.tools.getStor("date_order") ? moment(this.tools.getStor("date_order")) : "";
    const hourOrder = this.tools.getStor("hour_order") ? moment(this.tools.getStor("hour_order")) : "";
    let currDay: number | null = null;
    let currHour: string | null = null;
    let day: string | null = null;
    // if une date order
    if (dateOrder) {
      currDay = dateOrder.day();
      currHour = hourOrder ? hourOrder.format("HH:mm:ss") : now.format("HH:mm:ss");
      day = dateOrder.format("YYYY-MM-DD") + ' ' + currHour;
    }
    const lang = this.langServ.getLang();
    const params: ProductParams = {
      archive: 0,
      for_sale: 1,
      handle_price_period: 1,
      id_point_of_sale: this.tools.getStor("point_of_sale").id,
      id_sale_method: smId,
      language: lang,
      limit_from: $limit_from,
      price_period_date: day !== null ? day : null,
      price_period_day: currDay !== null ? currDay : null,
      price_period_hour: currHour !== null ? currHour : null,
      rubric_id: rubric_id,
      search: search,
      with_ht: 1,
    }
    return params;
  }

  // Récupère les produits en fonction de la methode de vente et d'autres parametres
  getProducts(smId: number, $limit_from: number | null, rubric_id: string | number | null, search: string | null, start: string | boolean | null, pricePeriods: PricePeriod[]): Promise<FulleParsedProds> {
    if (start)
      this.tools.removeStor("ids_suggestions");
    const params: ProductParams = this.getParamsProducts(
      smId,
      rubric_id,
      $limit_from,
      search
    );
    return new Promise(resolve => {
      this.baseClient.postBaseApi('products_rub', params).then((products: FulleProducts) => {
        // init le stock
        this.parsebasketProd(products, pricePeriods).then((parsedProds: FulleParsedProds) => {
          // Ajout de propriétés au produit pour les afficher sur le DOM
          parsedProds.count = products.count;
          parsedProds.num_rows = products.num_rows;
          parsedProds.products_to_display = products.products_to_display;
          parsedProds.next_limit_from = products.next_limit_from;
          parsedProds.displayDay = params.price_period_day; //currday
          parsedProds.displayHour = params.price_period_hour; //currHour
          if (parsedProds.products && parsedProds.products.length > 0) {
            const result = this.suggestions(parsedProds.products);
            if (result && result.length > 0) {
              // get products by suggestions ids
              this.getSuggestionProducts(result).then((products_suggestions: FulleProducts) => {
                this.Mysuggestions = products_suggestions.list ? products_suggestions.list : []
                resolve(parsedProds);
              })
            } else {
              resolve(parsedProds);
            }
          } else {
            resolve(parsedProds);
          }
        });
      });
    });
  }

  parsebasketProd(products: FulleProducts, pricePeriods: PricePeriod[]): Promise<FulleParsedProds> {
    return new Promise(resolve => {
      // Filtrage des produits dont le prix n'est pas libre
      const parsedProds = products.list.filter((prod: FulleProduct) => prod.free_price === 0);

      // Map pour assigner des valeurs supplémentaires à chaque produit
      parsedProds.map((p: FulleProduct) => {
        p.quantity = 1;
        p.price_period = null;

        // Si le produit a une période de prix, l'ajouter à l'objet produit
        if (p.prices[0].id_price_period && pricePeriods != null) {
          for (let j = 0; j < pricePeriods.length; j++) {
            if (p.prices[0].id_price_period === pricePeriods[j].id) {
              p.price_period = pricePeriods[j];
              break;
            }
          }
        }

        // Initialisation du stock
        p.stock = null;
        if (typeof this.stockApi.stocks == 'object') {
          p.stock = this.stockApi.stocks[p.id];
          if (p.categories.length > 0) {
            this.addstockCat(p);
          }
        }
      });

      // Retourne l'objet complet pour FulleParsedProds
      resolve({
        products: parsedProds,
        count: products.count || 0,
        displayDay: null, // ou toute valeur appropriée selon votre logique
        displayHour: null, // ou toute valeur appropriée selon votre logique
        next_limit_from: products.next_limit_from || null,
        num_rows: products.num_rows || 0,
        products_to_display: products.products_to_display || 0
      });
    });
  }

  // set  suggestions
  suggestions(products: FulleProduct[]) {
    const idsSuggestions: number[] = [];
    let uniqueArray: number[] = [];
    let idsSuggestionsLocalstorage = null;
    products.forEach((element: FulleProduct) => {
      if (element.suggestions && element.suggestions.length > 0) {
        element.suggestions.forEach((value: number) => {
          idsSuggestions.push(value);
        });
      }
    });
    if (idsSuggestions && idsSuggestions.length > 0) {
      idsSuggestionsLocalstorage = this.tools.getStor("ids_suggestions");
      if (idsSuggestionsLocalstorage && idsSuggestionsLocalstorage.length) {
        idsSuggestionsLocalstorage.forEach((element: any) => {
          idsSuggestions.push(element);
        });
      }
    }
    if (idsSuggestions && idsSuggestions.length == 0) {
      this.tools.removeStor("ids_suggestions");
    } else {
      uniqueArray = [...new Set(idsSuggestions)];
      this.tools.setStor("ids_suggestions", uniqueArray);
    }
    return uniqueArray;
  }

  // get Suggestions products
  getSuggestionProducts(ids_suggestions: number[]): Promise<FulleProducts> {
    return new Promise(resolve => {
      const params = {
        ids: ids_suggestions
      }
      this.baseClient.postBaseApi('products_suggestions', params).then(products_suggestions => {
        resolve(products_suggestions);
      })
    })
  }

  ////// Suggestions //////  

  // get Suggestions
  getSuggestions(prod: any) {
    const currBasket: any = this.tools.getStor(PanierService.TAG_STORAGE);
    const is_webshop_end = 0;
    const quantityProd: any = [];
    if (currBasket && currBasket.length > 0) {
      currBasket.forEach((prod: any) => {
        quantityProd['qte_' + prod.id] = quantityProd['qte_' + prod.id] ? quantityProd['qte_' + prod.id] + prod.quantity : prod.quantity;
      });
    }
    const result: any = [];
    if (prod.suggestions && prod.suggestions.length > 0) {
      prod.suggestions.forEach((element: any) => {
        //get suggest with is_webshop_end==0
        const suggestions = this.Mysuggestions.find((value: any) => (value.id == element && value.is_webshop_end == is_webshop_end));
        if (suggestions && suggestions.products && suggestions.products.length > 0) {
          suggestions['products_to_suggest'] = [];
          suggestions.products.forEach((id_product_sugg: any) => {
            let flag = false;
            //verifier si le produit n'est pas dans le panier
            if (currBasket && currBasket.length > 0) {
              if (quantityProd['qte_' + id_product_sugg] >= quantityProd['qte_' + prod.id]) {
                flag = true;
              }
            }
            if (!flag) {
              suggestions['products_to_suggest'].push(id_product_sugg);
            }
          })
          if (suggestions['products_to_suggest'].length > 0) {
            result.push(suggestions);
          }
        }
      });
    }
    return result;
  }


  // check Products Suggestions End
  checkProductsSuggestionsEnd(merchantClient?: any) {
    this.getSuggestionsEnd().then((mysuggestions: any) => {
      this.tools.setStor('SuggestionsEnd', true);
      if (mysuggestions && mysuggestions.length > 0) {
        this.setObserLoaderProductsSuggested(true);
        this.checkValidityProductsSuggestions(mysuggestions, merchantClient);
      } else {
        this.setObsersuggestionsEnd("fid");
      }
    })
  }

  // getSuggestions End
  getSuggestionsEnd(): Promise<any> {
    return new Promise(resolve => {
      const idsSuggestionsLocalstorage = this.tools.getStor("ids_suggestions") && this.tools.getStor("ids_suggestions").length > 0 ? this.tools.getStor("ids_suggestions") : null
      const is_webshop_end = 1;
      if (idsSuggestionsLocalstorage) {
        this.getSuggestionProducts(idsSuggestionsLocalstorage).then((products_suggestions: any) => {
          let suggestions_end = [];
          this.Mysuggestions = products_suggestions.list ? products_suggestions.list : []
          suggestions_end = this.Mysuggestions.filter((value: any) => (value.is_webshop_end == is_webshop_end));
          if (suggestions_end && suggestions_end.length > 0) {
            suggestions_end.forEach((element: any) => {
              if (element.products && element.products.length > 0)
                element['products_to_suggest'] = [];
              element.products.forEach((id_product_sugg: any) => {
                element['products_to_suggest'].push(id_product_sugg);
              })
            })
          }
          const currBasket: any = this.tools.getStor(PanierService.TAG_STORAGE);
          if (suggestions_end && currBasket) {
            const quantityProd: any = [];
            currBasket.forEach((prod: any) => {
              quantityProd['qte_' + prod.id] = quantityProd['qte_' + prod.id] ? quantityProd['qte_' + prod.id] + prod.quantity : prod.quantity;
            })
            currBasket.forEach((prod: any) => {
              if (prod.suggestions && prod.suggestions.length > 0) {
                prod.suggestions.forEach((element: any) => {
                  //get suggest with is_webshop_end
                  const suggestions = this.Mysuggestions.find((value: any) => (value.id == element && value.is_webshop_end == is_webshop_end));
                  if (suggestions && suggestions.products && suggestions.products.length > 0) {
                    suggestions['products_to_suggest'] = [];
                    suggestions.products.forEach((id_product_sugg: any) => {
                      let flag = false;
                      if (quantityProd['qte_' + id_product_sugg] >= quantityProd['qte_' + prod.id]) {
                        flag = true;
                      }
                      if (!flag) {
                        suggestions['products_to_suggest'].push(id_product_sugg);
                      }
                    })
                  }
                });
              }
            });
          }
          resolve(suggestions_end);
        })
      } else {
        resolve(null)
      }
    });
  }


  // check Products Suggestions first
  checkProductsSuggestions(prod: any, merchantClient?: any) {
    // console.log("checkProductsSuggestions - prod : ", prod);
    // console.log("checkProductsSuggestions - merchantClient : ", merchantClient);
    // prod.quantity==1 &&
    if (prod.suggestions && prod.suggestions.length > 0) {
      //suggestions
      const mysuggestions = this.getSuggestions(prod);
      // console.log("checkProductsSuggestions - mysuggestions : ", mysuggestions);

      if (mysuggestions && mysuggestions.length > 0) {
        this.setObserLoaderProductsSuggested(true);
        this.checkValidityProductsSuggestions(mysuggestions, merchantClient);
      }
    }
  }

  // checkValidty des products suggered
  checkValidityProductsSuggestions(suggestions: any, merchantClient?: any) {
    this.getValidProductsSuggestion(suggestions).then(data => {
      // console.log("getValidProductsSuggestion ok");
      // console.log("data");
      this.setObsersuggestionsEnd(false);
      this.setObserLoaderProductsSuggested(false);
      if (data && data.length > 0) {
        this.openSuggestionsProductsDial(data, merchantClient);
      } else {
        this.setObserLoaderProductsSuggested("fid");
      }
    })
  }

  // Ouvre la popup des produits suggerer
  openSuggestionsProductsDial(suggestions: any, merchantClient?: any) {
    const myConf = new MatDialogConfig();
    myConf.data = {
      suggestions: suggestions,
      merchantClient: merchantClient
    };
    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "780px", myConf.height = "100%");
    const myDial = this.dialog.open(ProductSuggestionsComponent, myConf);
    myDial.disableClose = true;
    myDial.afterClosed().subscribe(() => {
      this.setObsersuggestionsEnd("fid")
    });
  }

  // get Valid Products Suggestion
  getValidProductsSuggestion(suggestions: Suggestions[], dateOrder?: any, hourOrder?: any): Promise<any> {
    console.log("[TYPAGE] getValidProductsSuggestion - dateOrder : ", dateOrder);
    console.log("[TYPAGE] getValidProductsSuggestion - hourOrder : ", hourOrder);
    const date: any = dateOrder ? dateOrder : this.tools.getStor("date_order");
    console.log("[TYPAGE] getValidProductsSuggestion - dateOrder : ", dateOrder);

    const hour: any = hourOrder ? hourOrder : this.tools.getStor("hour_order");
    console.log("[TYPAGE] getValidProductsSuggestion - hourOrder : ", hourOrder);

    const pos: any = this.tools.getStor("point_of_sale");
    console.log("[TYPAGE] getValidProductsSuggestion - pos : ", pos);

    const sm: SaleMethodSlim = this.tools.getStor(SalemethodService.TAG_STORAGE);
    console.log("[TYPAGE] getValidProductsSuggestion - sm : ", sm);

    const params: any = {
      suggestions: suggestions,
      pos_id: pos.id,
      sm_id: sm.id,
      date_order: date ? moment(date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      hour_order: hour ? moment(hour).format("HH:mm:ss") : moment().add(30, 'seconds').format("HH:mm:ss"),
      id_merchant: this.tools.getStor("id_merchant")
    }
    return new Promise(resolve => {
      this.baseClient.postBase("validProductsSuggestion", params).then((products: FulleProducts) => {
        if (products && products.code < 0 || products.list && products.list.length == 0) {
          resolve([]);
        }
        else {
          // init le stock
          this.parsebasketProd(products, []).then((parsedProds: FulleParsedProds) => {
            const prods = this.setValidProductStock(parsedProds.products, suggestions);
            resolve(prods);
          });
        }
      });
    });
  }

  // set Products Suggestion
  setValidProductStock(parsedProds: FulleProduct[], sugge: Suggestions[]) {
    const suggestions = sugge;
    if ((parsedProds && parsedProds.length > 0)) {
      parsedProds.forEach((element: FulleProduct) => {
        if ((!element.stock || element.stock && element.stock.count && element.stock.count > 0) && element.product_type < 2) {
          if (suggestions && suggestions.length > 0) {
            suggestions.forEach((ele: Suggestions) => {
              if (ele && ele.products_to_suggest && ele.products_to_suggest.length > 0) {
                ele.products_to_suggest.forEach((el: number) => {
                  if (element.id == el) {
                    if (!ele.products_exist_suggestions) {
                      ele.products_exist_suggestions = [];
                    }
                    if (element.product_type < 2) {
                      element.suggestion_id = ele.id;
                      ele.products_exist_suggestions.push(element);
                    }
                  }
                });
              }
            });
          }
        }
      });
    }
    const array: Suggestions[] = [];
    if (suggestions && suggestions.length > 0) {
      suggestions.forEach((ele: Suggestions) => {
        if (ele && ele.products_exist_suggestions && ele.products_exist_suggestions.length > 0) {
          array.push(ele);
        }
      })
    }
    if (array && array.length > 0) {
      array.forEach((ele: Suggestions) => {
        const group: any = []
        let result = []
        if (ele && ele.products_exist_suggestions && ele.products_exist_suggestions.length > 0) {
          ele.products_exist_suggestions.forEach((element: FulleProduct) => {
            !group['rub_' + element.rubric.id] ? group['rub_' + element.rubric.id] = [element] :
              group['rub_' + element.rubric.id].push(element)
          });
          // //group by rubrics
          result = Object.keys(group).map(key => ({
            rubric_name: group[key][0].rubric.name,
            rubric_id: group[key][0].rubric.id,
            products: group[key].sort(() => Math.random() - 0.5)
          }))
          ele.products_exist_suggestions_list = result
          ele.products_exist_suggestions = ele.products_exist_suggestions.sort(() => Math.random() - 0.5);
        }
      })
    }
    return array;
  }

  // getFormulesAuto(product: any, merchantClient?: any, categories?: any, dateOrder?: any, hourOrder?: any) {
  //   this.setObserLoaderFormulePSuggested(true);
  //   return new Promise(resolve => {
  //     const date: any = dateOrder ? dateOrder : this.tools.getStor("date_order");
  //     const hour: any = hourOrder ? hourOrder : this.tools.getStor("hour_order");
  //     const pos: any = this.tools.getStor("point_of_sale");
  //     const sm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
  //     let params: any = {
  //       id_product: product.id,
  //       pos_id: pos.id,
  //       sm_id: sm.id,
  //       date_order: date ? moment(date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
  //       hour_order: hour ? moment(hour).format("HH:mm:ss") : moment().add(30, 'seconds').format("HH:mm:ss"),
  //       id_merchant: this.tools.getStor("id_merchant")
  //     }
  //     params.price_period_date = params.date_order + ' ' + params.hour_order;
  //     // Récupération des suggestions de formules
  //     this.baseClient.postBaseApi('formules_suggestions', params).then(products => {
  //       // console.log("formules_suggestions");
  //       // console.log(products);
  //       if (products.list && products.list.length > 0) {
  //         this.parsebasketProd(products, []).then((parsedProds : FulleParsedProds) => {
  //           // affichage formule sans stock
  //           let newparsedProds: any = []
  //           if (parsedProds.products && parsedProds.products.length > 0) {
  //             parsedProds.products.forEach((element: any) => {
  //               if (!element.stock || (element.stock && element.stock.count > 0)) {
  //                 newparsedProds.push(element);
  //               }
  //             });
  //             parsedProds.products = newparsedProds;
  //           }
  //           resolve(parsedProds);
  //           if (newparsedProds && newparsedProds.length > 0) {
  //             this.openSuggestionsFormulesProductsDial(product, parsedProds, merchantClient, categories);
  //           }
  //         })
  //       } else {
  //         resolve(null);
  //         this.setObserLoaderFormulePSuggested(false);
  //       }
  //     });
  //   })
  // }

  // Ouvre la popup des formules à suggerer
  // openSuggestionsFormulesProductsDial(product: any, suggestionFormules: any, merchantClient?: any, categories?: any) {
  //   const myConf = new MatDialogConfig();
  //   myConf.data = {
  //     suggestionFormules: suggestionFormules.products,
  //     merchantClient: merchantClient,
  //     prodselected: product,
  //     categories: categories
  //   };
  //   this.media.isActive("xs")
  //     ? (myConf.width = "100%", myConf.height = "100%")
  //     : (myConf.width = "780px", myConf.height = "100%");
  //   const myDial = this.dialog.open(FormulesSuggestionsComponent, myConf);
  //   myDial.disableClose = true;
  //   myDial.afterClosed().subscribe((result) => {
  //     // loader and close dial
  //     if (!result) {
  //       this.checkProductsSuggestions(product, merchantClient);
  //       result = "data";
  //     }
  //     this.setObserLoaderFormulePSuggested(false, result);
  //   });
  // }

  // getNewProduct(date_prod: any) {
  //   let now = moment().subtract(7, 'days')
  //   now.format("YYYY-MM-DD");
  //   return moment(date_prod).format("YYYY-MM-DD") > now.format("YYYY-MM-DD") ? true : false;
  // }
}
